
import { Injectable} from '@angular/core';
import { Http, Headers, Response } from '@angular/http'; 
import { Globals } from '../_Globals/globals'; 

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable() 
export class VehicleService {
    public token: string; 

    constructor(private http: Http, private globals: Globals) {
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token; 
    } 
  

    getVehicleByOfs(page: Number, getParam: any[]): Observable<any> { 
        var param = 'search=';
        if(getParam != null) {
            param = this._buildParams(getParam);
        }
        console.log(this.globals.api_url + 'vehicles/imported/page:' + page + '?' + param);
        return this.http.get(this.globals.api_url + 'vehicles/imported/page:' + page + '?' + param)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    getVehicles(debt_imported_id: Number, page: Number, getParam: any[]): Observable<any> { 
        var param = 'search=';
        if(getParam != null) {
            param = this._buildParams(getParam);
        }
        console.log(this.globals.api_url + 'vehicles/imported/page:' + page + '?' + param);
        return this.http.get(this.globals.api_url + 'vehicles/index/' + debt_imported_id + '/page:'+page + '?' + param)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    getBroadcasts(page: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'vehicles/broadcast/page:'+page)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    getVehicle(id: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'vehicles/view/' + id)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }
    private _buildParams(params: any) {
        let urlSearchParams = new URLSearchParams();

        for(let key in params){
            if(params.hasOwnProperty(key)){
                urlSearchParams.append(key, params[key]);
            }
        }
        return urlSearchParams.toString();
    }
}


// WEBPACK FOOTER //
// ./src/app/_Services/vehicle.service.ts